import * as React from "react";
import { CircularProgress } from "@mui/material";
import { connect } from "react-redux";

interface FooterButtonsProps {
    loading?: boolean;
    onClose?: () => void;
    onBack?: () => void;
    onSubmit?: () => void;
    locales?: {
        cancel?: string;
        back?: string;
        next?: string;
    },
    settings?: any
}

// Registration wizard buttons, like the fixed bottom buttons on mobile: Cancel (quiet), Back, Next (primary).
export const FooterButtons: React.FC<FooterButtonsProps> = props => {
    const {
        onClose,
        onBack,
        onSubmit,
        locales,
        loading,
    } = props;

    return (
        <div className="pb-reg-footer">
            {onClose && <button type="button" className="pb-btn pb-btn-outline" onClick={() => onClose()}>
                {locales?.cancel ? locales.cancel : 'Cancel'}
            </button>}

            {onBack && <button type="button" className="pb-btn pb-btn-ink" onClick={() => onBack()}>
                {locales?.back ? locales.back : 'Back'}
            </button>}

            {onSubmit && <button type="button" className="pb-btn pb-btn-primary" onClick={() => onSubmit()} disabled={loading}>
                {loading ? <CircularProgress size={20} style={{ color: "#fff" }} /> : (locales?.next ? locales.next : 'Next')}
            </button>}
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
})

export default connect(mapStateToProps, null)(React.memo(FooterButtons))
